import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-registration-error404',
  templateUrl: './registration-error404.component.html',
  styleUrls: ['./registration-error404.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistrationError404Component {
  url = 'https://simpliedtech.com/';
}
